export default __webpack_public_path__ + "static/media/Drivers-Monitoring.377b7211.jpg";